import { useEffect } from 'react';
import confetti from 'canvas-confetti';

// "School pride" side-cannon confetti (per the canvas-confetti recipe): two
// streams fire inward from the left and right edges for `duration` ms. Used on
// the "Your provider will likely recommend treatment." recommendation slide.
// Brand colors (green + white) instead of the recipe's red/white.
export function fireSchoolPride({
  duration = 15 * 1000,
  colors = ['#2d8a5f', '#ffffff', '#7bc9a0'],
} = {}) {
  if (typeof window === 'undefined') return () => {};
  // Respect reduced-motion preference (accessibility).
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return () => {};
  }

  const end = Date.now() + duration;
  let raf = 0;
  let stopped = false;

  (function frame() {
    if (stopped) return;
    confetti({ particleCount: 2, angle: 60, spread: 55, origin: { x: 0 }, colors });
    confetti({ particleCount: 2, angle: 120, spread: 55, origin: { x: 1 }, colors });
    if (Date.now() < end) raf = requestAnimationFrame(frame);
  })();

  return () => {
    stopped = true;
    if (raf) cancelAnimationFrame(raf);
  };
}

// Fires the school-pride burst once whenever `enabled` becomes true (e.g. the
// recommendation slide mounts / is shown); cancels the loop on unmount or when
// `enabled` flips false (e.g. advancing to the pay phase).
export function useSchoolPrideConfetti(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const cancel = fireSchoolPride();
    return cancel;
  }, [enabled]);
}
